import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";

const REAL_WIDGET_URL = process.env.REACT_APP_DEMO_WIDGET_URL;

export default function WidgetGate() {
  const { widgetId } = useParams();
  const [state, setState] = useState({ loading: true, active: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/widget/${widgetId}/status`);
        if (cancelled) return;
        setState({ loading: false, active: data.active, status: data.status });
      } catch {
        if (cancelled) return;
        setState({ loading: false, active: false, status: "inactive" });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [widgetId]);

  if (state.loading) {
    // Render nothing while we resolve status — keeps the embed quiet.
    return <div data-testid="widget-gate-loading" />;
  }

  if (!state.active) {
    // Required behaviour: completely blank div, no message, no error UI.
    return <div data-testid="widget-gate-blank" />;
  }

  // Active — render the live quoting widget. The real widget is hosted in a separate
  // service; we proxy via iframe so the parent site's snippet stays a single embed.
  return (
    <iframe
      data-testid="widget-gate-iframe"
      title="GenQuotes Widget"
      src={REAL_WIDGET_URL}
      style={{ width: "100%", height: "100vh", border: 0, display: "block", background: "#fff" }}
    />
  );
}
